import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import PayQuote from "@/pages/PayQuote";
import PaySuccess from "@/pages/PaySuccess";
import Admin from "@/pages/Admin";
import ArticlesList from "@/pages/ArticlesList";
import ArticleDetail from "@/pages/ArticleDetail";
import "@/index.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/approfondimenti" element={<ArticlesList />} />
        <Route path="/approfondimenti/:slug" element={<ArticleDetail />} />
        <Route path="/pay/success" element={<PaySuccess />} />
        <Route path="/pay/:quoteId" element={<PayQuote />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#FAF9F6",
            border: "1px solid rgba(250,249,246,0.1)",
            borderRadius: 0,
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
